/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronMiniRight: {
  name: 'chevron-mini-right';
  data: string;
} = {
  name: 'chevron-mini-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.646 5.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L8.293 8 6.646 6.354a.5.5 0 0 1 0-.708Z" fill="currentColor"/></svg>`,
};
